import { render } from "./ClockinLoader.vue?vue&type=template&id=90f7f7e2"
import script from "./ClockinLoader.vue?vue&type=script&lang=js"
export * from "./ClockinLoader.vue?vue&type=script&lang=js"

import "./ClockinLoader.vue?vue&type=style&index=0&id=90f7f7e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__